import {PreviewWithEdit} from 'shells/preview-with-edit/preview-with-edit';

import type {FormCreateRulesUpdateInput, MultiPageFormFragment} from 'nutshell-graphql-types';

import {FormPageContainer} from '../form-main-tab/form-page-container';
import {nextStepsCacheUpdate} from '../form-main-tab/helpers';
import {useUpdateCreateRules} from '../form-main-tab/use-update-create-rules';
import {PeanutFormPreview} from '../peanut-form-preview/peanut-form-preview';

interface Props {
    form: MultiPageFormFragment;
}

export function MultiPageFormMainTab(props: Props) {
    const updateCreateRules = useUpdateCreateRules();

    return (
        <FormPageContainer
            formId={props.form.id}
            formType={props.form.type}
            title='Form'
            formContent={
                <PreviewWithEdit
                    noun='form'
                    to={`/email-marketing/forms/${props.form.id}/editor`}
                    preview={
                        <PeanutFormPreview
                            publicFormId={props.form.publicFormId}
                            instanceId={NutshellFrontendSettings.instanceId}
                            isNoTouchPreview={true}
                        />
                    }
                />
            }
            spamPreventionType={props.form.spamPreventionType}
            afterSubmissionProps={{
                afterSubmissionText: props.form.editableVersion.afterSubmissionText,
                redirectUrl: props.form.editableVersion.redirectUrl,
            }}
            createRulesProps={{
                hasAccountFields: props.form.editableVersion.hasAccountFields,
                hasContactFields: props.form.editableVersion.hasContactFields,
                hasLeadFields: props.form.editableVersion.hasLeadFields,
                createRules: props.form.createRules,
                updateCreateRules: (input: FormCreateRulesUpdateInput) => updateCreateRules(input),
            }}
            nextStepsProps={{
                description: 'Notifications will automatically send when this form is submitted.',
                bodyText: 'When this form is submitted…',
                slackMessagePreviewMessage: `${props.form.name} was submitted! 🧲`,
                nextSteps: props.form.nextSteps,
                onUpdateSuccess: nextStepsCacheUpdate,
            }}
        />
    );
}
